
// verifyCondition_quickMessages: Esta función verifica si se cumple la condición para que se 
// renderice el componente.
export const verifyCondition_quickMessages = ( socketConnected, filesSelected ) => {
    let condition = (filesSelected.length === 0 && socketConnected);
    return condition;
}
